import React from 'react';

const Logo = () => (
  <svg
    id="Laag_1"
    data-name="Laag 1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 316.23 180.05"
  >
    <defs>
      <style
        dangerouslySetInnerHTML={{
          __html: `
      .cls-1 {
        fill: none;
      }

      .cls-2 {
        clip-path: url(#clippath-1);
      }

      .cls-3 {
        fill: #fff;
      }

      .cls-4 {
        fill: #00936f;
      }

      .cls-5 {
        clip-path: url(#clippath);
      }
    `,
        }}
      />
      <clipPath id="clippath">
        <rect className="cls-1" y="0" width="316.23" height="180.04" />
      </clipPath>
      <clipPath id="clippath-1">
        <rect className="cls-1" y="0" width="316.23" height="180.04" />
      </clipPath>
    </defs>
    <g className="cls-5">
      <path
        className="cls-4"
        d="M316.23,64.06C98.01-41.05,17.91-18.37,0,143.63c246.1,82.62,296.44,11.11,316.23-79.73"
      />
      <path
        className="cls-3"
        d="M101.79,119.01c-5.63-14.77-17.19-49.25-22.57-61.07-2.78-6.11-6.15-6.62-9.17-6.66-2.55-.04-4.27.13-6.14.1-1.12-.02-1.61.36-2,1.39-1.28,3.4-2.59,6.8-3.89,10.19h0c-1.05,2.71-2.14,5.57-3.25,8.48-.53,1.38-1.06,2.75-1.59,4.13-2.1,5.48-4.19,10.96-6.28,16.44h.04c-1.77,4.62-3.36,8.77-4.61,11.93-.48,1.22-.46,1.23.81,1.24,1.13.03,4.12.22,7,.28,2.67.06,5.12-1.47,6.09-3.96.4-1.02,1.55-4.15,3.01-8.17,1.47,0,9.83-.02,12.39-.03,1.07,0,1.07,0,.71-.99-.21-.59-1.81-5.26-3.06-8.91h-6.41c1.16-3.15,2.32-6.32,3.37-9.13,1.11-2.8,2.13-5.41,2.93-7.68.07-.18.17-.34.34-.69.92,2.67,1.77,5.16,2.64,7.64.3.87,1.55,4.46,3.19,9.19l3.86,11.12c3.5,10.06,7.12,20.44,7.87,22.4,1,2.66,3.58,4.31,6.42,4.28,3.05-.03,6.23-.18,7.43-.2,1.35,0,1.37,0,.88-1.31M133.4,68.61c.69-1.9.71-1.9-1.27-1.9h-5.75c-3.21,0-6.06,2.05-7.08,5.09-1.81,5.38-4.59,13.73-6.06,18.45-.34,1.1-.71,2.19-1.09,3.38-.38-.28-.41-.56-.49-.81-1.04-3.31-2.1-6.62-3.13-9.94-.81-2.64-2.1-6.94-3.14-10.43-1-3.35-4.06-5.67-7.56-5.71-2.76-.04-5.66-.06-6.71-.04-.78,0-.99.32-.65,1.06.06.12.09.25.13.38,3.33,9.15,9.14,25.12,12.36,33.99,1.39,3.83,5.04,6.38,9.12,6.37,3.96,0,7.51-2.44,8.97-6.12.52-1.31,1.01-2.57,1.33-3.46,3.66-10.1,7.33-20.21,11-30.31M160.5,83.39c-2.18,0-4.36,0-6.55,0s-4.3,0-6.45,0c-.43,0-.92.06-.76-.66.64-2.78,2.51-5.79,5.63-6.43,5.07-1.04,8.07,2.04,9,6.28.16.75-.31.81-.87.81M168.18,71.8c-4.66-4.97-10.6-6.77-17.27-5.75-6.48.99-11.46,4.38-14.48,10.28-3.33,6.5-3.65,13.24-1.15,20.08,2.01,5.48,5.79,9.35,11.25,11.45,4.57,1.76,9.29,2,14.06,1,3.98-.83,7.48-2.6,10.41-5.46.61-.6.7-1.05.1-1.73-.25-.28-.53-.61-.85-.98-2.42-2.81-6.35-3.76-9.82-2.44-.62.24-1.25.42-1.87.51-5.42,1.24-9.96-1.18-11.54-6.13-.36-1.14-.29-1.24.92-1.24,4.01,0,8.01,0,12.02,0,4.04,0,8.08-.01,12.12,0,.72,0,1.19-.13,1.33-.95,1.25-7.06-.32-13.4-5.23-18.66M216.78,68.61c.69-1.9.71-1.9-1.26-1.9h-5.75c-3.21,0-6.06,2.05-7.08,5.09-1.81,5.38-4.59,13.73-6.06,18.45-.34,1.1-.71,2.19-1.09,3.38-.38-.28-.41-.56-.49-.81-1.04-3.31-2.1-6.62-3.12-9.94-.82-2.64-2.1-6.94-3.14-10.43-1-3.35-4.06-5.67-7.56-5.71-2.76-.04-5.66-.06-6.71-.04-.78,0-.99.32-.64,1.06.06.12.09.25.13.38,3.33,9.15,9.14,25.12,12.36,33.99,1.4,3.83,5.04,6.38,9.12,6.37,3.96,0,7.51-2.44,8.97-6.12.52-1.31,1.01-2.57,1.33-3.46,3.66-10.1,7.33-20.21,11-30.31M244.06,83.39c-2.18,0-4.36,0-6.55,0s-4.3,0-6.45,0c-.43,0-.92.06-.76-.66.64-2.78,2.51-5.79,5.63-6.43,5.07-1.04,8.07,2.04,9,6.28.16.75-.31.81-.87.81M251.73,71.8c-4.65-4.97-10.6-6.77-17.27-5.75-6.48.99-11.45,4.38-14.48,10.28-3.33,6.5-3.65,13.24-1.15,20.08,2.01,5.48,5.79,9.35,11.25,11.45,4.57,1.76,9.29,2,14.06,1,3.98-.83,7.48-2.6,10.41-5.46.62-.6.7-1.05.1-1.73-.25-.28-.53-.61-.85-.98-2.42-2.81-6.35-3.76-9.82-2.44-.62.24-1.25.42-1.87.51-5.42,1.24-9.96-1.18-11.55-6.13-.36-1.14-.29-1.24.92-1.24,4.01,0,8.01,0,12.02,0,4.04,0,8.08-.01,12.12,0,.72,0,1.19-.13,1.33-.95,1.25-7.06-.32-13.4-5.23-18.66"
      />
      <path
        className="cls-3"
        d="M93.37,140.5c1.2,0,2.2-.98,2.2-2.71s-.89-2.75-2.18-2.75c-1.14,0-2.2.83-2.2,2.77,0,1.36.74,2.7,2.18,2.7M89.07,133.37h1.99v.64c0,.33-.03.6-.03.6h.03s.76-1.44,2.82-1.44c2.37,0,3.88,1.87,3.88,4.59s-1.7,4.59-4,4.59c-1.74,0-2.51-1.2-2.51-1.2h-.03s.03.31.03.76v3.68h-2.18v-12.21Z"
      />
      <path
        className="cls-3"
        d="M102.22,140.64c1.15,0,1.98-1.24,1.98-2.3v-.21h-.38c-1.12,0-2.92.15-2.92,1.38,0,.58.43,1.13,1.32,1.13M103.89,136.64h.29v-.12c0-1.15-.72-1.55-1.68-1.55-1.26,0-2.41.84-2.41.84l-.83-1.56s1.36-1.08,3.44-1.08c2.3,0,3.64,1.27,3.64,3.49v5.48h-2.01v-.72c0-.34.03-.62.03-.62h-.03s-.67,1.55-2.66,1.55c-1.56,0-2.97-.98-2.97-2.73,0-2.79,3.76-2.97,5.19-2.97"
      />
      <path
        className="cls-3"
        d="M108.69,139.52s.96.96,2.39.96c.62,0,1.15-.28,1.15-.79,0-1.31-4.26-1.14-4.26-3.95,0-1.63,1.46-2.58,3.35-2.58s2.94,1,2.94,1l-.81,1.62s-.81-.76-2.15-.76c-.57,0-1.12.24-1.12.79,0,1.24,4.26,1.08,4.26,3.9,0,1.46-1.27,2.63-3.35,2.63s-3.4-1.29-3.4-1.29l1-1.53Z"
      />
      <path
        className="cls-3"
        d="M116.28,139.52s.96.96,2.39.96c.62,0,1.15-.28,1.15-.79,0-1.31-4.26-1.14-4.26-3.95,0-1.63,1.46-2.58,3.35-2.58s2.94,1,2.94,1l-.81,1.62s-.81-.76-2.15-.76c-.57,0-1.12.24-1.12.79,0,1.24,4.26,1.08,4.26,3.9,0,1.46-1.27,2.63-3.35,2.63s-3.4-1.29-3.4-1.29l1-1.53Z"
      />
    </g>
    <path className="cls-3" d="M123.65,142.14h2.18v-8.77h-2.18v8.77ZM123.65,131.88h2.16v-1.94h-2.16v1.94Z" />
    <g className="cls-2">
      <path
        className="cls-3"
        d="M133.56,136.67c-.03-1.19-.77-1.82-1.74-1.82-1.12,0-1.89.69-2.1,1.82h3.83ZM131.88,133.17c2.53,0,3.88,1.84,3.88,4.16,0,.26-.05.84-.05.84h-6.05c.14,1.53,1.32,2.32,2.63,2.32,1.41,0,2.53-.96,2.53-.96l.84,1.56s-1.34,1.25-3.52,1.25c-2.9,0-4.71-2.1-4.71-4.59,0-2.7,1.84-4.59,4.45-4.59"
      />
      <path
        className="cls-3"
        d="M140.54,133.37h2.3l1.82,5.43c.17.52.29,1.32.31,1.32h.03s.14-.81.31-1.32l1.82-5.43h2.3l-3.15,8.77h-2.58l-3.18-8.77Z"
      />
      <path
        className="cls-3"
        d="M154.46,140.49c1.41,0,2.6-1.1,2.6-2.73s-1.19-2.73-2.6-2.73-2.61,1.12-2.61,2.73,1.18,2.73,2.61,2.73M154.44,133.17c2.68,0,4.83,1.91,4.83,4.59s-2.15,4.59-4.81,4.59-4.83-1.89-4.83-4.59,2.15-4.59,4.81-4.59"
      />
      <path
        className="cls-3"
        d="M165.09,140.49c1.41,0,2.59-1.1,2.59-2.73s-1.18-2.73-2.59-2.73-2.61,1.12-2.61,2.73,1.18,2.73,2.61,2.73M165.07,133.17c2.68,0,4.83,1.91,4.83,4.59s-2.15,4.59-4.81,4.59-4.83-1.89-4.83-4.59,2.15-4.59,4.81-4.59"
      />
      <path
        className="cls-3"
        d="M171.5,133.37h2.1v1.51c0,.33-.03.62-.03.62h.03c.39-1.25,1.44-2.25,2.79-2.25.21,0,.39.03.39.03v2.15s-.22-.03-.51-.03c-.93,0-1.98.53-2.39,1.84-.14.43-.19.91-.19,1.42v3.47h-2.18v-8.77Z"
      />
      <path
        className="cls-3"
        d="M182.31,129.93h2.16v9.14c0,.96.33,1.2.89,1.2.17,0,.33-.02.33-.02v1.91s-.33.05-.69.05c-1.2,0-2.7-.31-2.7-2.82v-9.47Z"
      />
      <path
        className="cls-3"
        d="M190.06,140.64c1.15,0,1.98-1.24,1.98-2.3v-.21h-.38c-1.12,0-2.92.15-2.92,1.38,0,.58.43,1.13,1.32,1.13M191.72,136.64h.29v-.12c0-1.15-.72-1.55-1.68-1.55-1.25,0-2.41.84-2.41.84l-.82-1.56s1.36-1.08,3.44-1.08c2.3,0,3.64,1.27,3.64,3.49v5.48h-2.01v-.72c0-.34.03-.62.03-.62h-.03s-.67,1.55-2.66,1.55c-1.56,0-2.97-.98-2.97-2.73,0-2.79,3.76-2.97,5.19-2.97"
      />
      <path
        className="cls-3"
        d="M196.27,133.37h2.1v1.02c0,.33-.03.6-.03.6h.03c.38-.74,1.34-1.82,3.11-1.82,1.94,0,3.04,1.02,3.04,3.33v5.64h-2.17v-5.19c0-1.07-.28-1.79-1.39-1.79s-2.03.74-2.36,1.79c-.12.36-.15.76-.15,1.17v4.02h-2.18v-8.77Z"
      />
      <path
        className="cls-3"
        d="M210.49,140.5c1.14,0,2.2-.82,2.2-2.77,0-1.36-.72-2.7-2.18-2.7-1.2,0-2.2.98-2.2,2.72s.89,2.75,2.18,2.75M210.08,133.17c1.92,0,2.53,1.12,2.53,1.12h.03s-.02-.23-.02-.5v-3.85h2.18v12.2h-2.06v-.72c0-.33.04-.57.04-.57h-.04s-.74,1.49-2.75,1.49c-2.37,0-3.88-1.87-3.88-4.59s1.65-4.59,3.97-4.59"
      />
      <path
        className="cls-3"
        d="M221.26,140.5c1.2,0,2.2-.98,2.2-2.71s-.89-2.75-2.18-2.75c-1.14,0-2.2.82-2.2,2.77,0,1.36.72,2.7,2.18,2.7M216.97,129.93h2.18v3.76c0,.43-.03.74-.03.74h.03s.77-1.27,2.63-1.27c2.37,0,3.88,1.87,3.88,4.59s-1.7,4.59-4.02,4.59c-1.82,0-2.61-1.31-2.61-1.31h-.03s.03.26.03.6v.5h-2.06v-12.2Z"
      />
      <path
        className="cls-3"
        d="M231.59,140.49c1.41,0,2.59-1.1,2.59-2.73s-1.18-2.73-2.59-2.73-2.61,1.12-2.61,2.73,1.19,2.73,2.61,2.73M231.58,133.17c2.68,0,4.83,1.91,4.83,4.59s-2.15,4.59-4.81,4.59-4.83-1.89-4.83-4.59,2.15-4.59,4.81-4.59"
      />
      <path
        className="cls-3"
        d="M237.88,133.37h2.18v5.19c0,1.07.27,1.79,1.36,1.79,1.58,0,2.46-1.39,2.46-2.95v-4.02h2.18v8.77h-2.1v-1c0-.34.03-.62.03-.62h-.03c-.43.91-1.55,1.82-3.04,1.82-1.87,0-3.04-.94-3.04-3.33v-5.64Z"
      />
      <path
        className="cls-3"
        d="M247.21,133.37h2.3l1.53,5.76c.12.46.17.93.17.93h.03s.09-.46.21-.93l1.62-5.74h1.94l1.62,5.74c.12.46.19.93.19.93h.04s.07-.46.19-.93l1.53-5.76h2.27l-2.67,8.77h-2.42l-1.48-5c-.14-.46-.22-.94-.22-.94h-.03s-.07.48-.21.94l-1.48,5h-2.44l-2.68-8.77Z"
      />
    </g>
  </svg>
);

export default Logo;
